import React from "react";
import { ClientSelectContainer } from "../../client-select";

export type ClientFilterProps = {
  setSelectedKeys: (selectedKeys: number[]) => void;
  selectedKeys: number[];
  confirm: () => void;
  clearFilters: () => void;
};

export const filterClient = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
}: ClientFilterProps) => (
  <ClientSelectContainer
    selectedFilterValues={selectedKeys as number[]}
    onApplyFilter={(values: number[]) => {
      setSelectedKeys(values);
      confirm();
    }}
    onClearFilter={() => {
      clearFilters();
      confirm();
    }}
  />
);

export const createClientFilterWithPreselection = (preselectedClientIds: number[]) => {
  return ({ setSelectedKeys, confirm, clearFilters }: ClientFilterProps) => (
    <ClientSelectContainer
      preselectedClientIds={preselectedClientIds}
      onApplyFilter={(values: number[]) => {
        setSelectedKeys(values);
        confirm();
      }}
      onClearFilter={() => {
        clearFilters();
        confirm();
      }}
    />
  );
};
